import {createStore} from 'vuex'

export default createStore({
    state: {
        appConfiguration: {},
        UserWM2Settings: [],
        userOptions: [],
        countries : ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua & Deps", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Central African Rep", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Congo {Democratic Rep}", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland {Republic}", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea North", "Korea South", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar, {Burma}", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russian Federation", "Rwanda", "St Kitts & Nevis", "St Lucia", "Saint Vincent & the Grenadines", "Samoa", "San Marino", "Sao Tome & Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad & Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"],
        availableFields: ['userName', 'displayName', 'phoneNumber', 'email', 'subContractorName', 'password', 'taxCode', 'permissionCards', 'introduceCourseAssignment'],
    },
    getters: {
        getUserWM2SettingsByKey: state => {
            return window._.keyBy(state.UserWM2Settings, 'SettingKey');
        }
    },
    mutations: {
        setAppConfiguration(state, value) {
            state.appConfiguration = value;
        },
        setUserWM2Settings(state, value) {
            state.UserWM2Settings = value;
        },
    },
    actions: {
        get(context, config) {
            if (!config) {
                window.alertify.error("get-metodin konfiguraatio puuttuu!");
                return false;
            }

            var parameters = config && config.parameters ? window.stringify(config.parameters) : "";
            var route = window.vm.basePath + config.route + "?" + parameters;

            if (!route) {
                window.alertify.error("Reititys puuttuu!");
                return false;
            }

            return window.axios.get(route)
                .then(response => {
                    return response.data;
                }).catch(error => {
                    if(error?.response?.status === 401) {
                        window.alertify.error("Istuntosi on vanhentunut. Ohjataan kirjautumiseen...", 3);
                        setTimeout(() => {
                            window.location = window.vm.basePath;
                        }, 4000)
                    }
                    console.log(error);
                    throw error;
                });
        },
        post(context, config) {
            if (!config) {
                window.alertify.error("post-metodin konfiguraatio puuttuu!");
                return false;
            }

            var route = window.vm.basePath + config.route;

            if (!route) {
                window.alertify.error("Reititys puuttuu!");
                return false;
            }

            return window.axios.post(route, config.parameters)
                .then(response => {
                    return response.data;
                }).catch(error => {
                    if(error?.response?.status === 401) {
                        window.alertify.error("Istuntosi on vanhentunut. Ohjataan kirjautumiseen...", 3);
                        setTimeout(() => {
                            window.location = window.vm.basePath;
                        }, 4000)
                    }
                    console.log(error.response);
                    if(error?.response?.data?.Message) {
                        window.alertify.error("Tapahtui virhe: " + error.response.data.Message, 5);
                    }
                    console.log(error);
                    throw error;
                });
        },
        getUserInfo(context, config = {}) {
            return this.dispatch('post', {
                route: "User/GetUser",
                parameters: config.parameters
            }).then(results => {
                return results
            }).catch((e)=> {
                console.log("Error:", e);
            })
        },
    },
    modules: {}
})
